'use strict';

var template = require('../../templates/ad-myapps.tpl');

function MyAppsList() {

}

MyAppsList.prototype.render = function(config, deps) {
	var _ = deps.underscore;
	var l = deps.l10nFn;
	var options = Object.assign(
		{ myapps: { content: [] } },
		config,
		{
			listAllApps: l('List.all.apps'),
			href: config.CHANNEL_SETTINGS.channelCanonicalBaseUrl + '/myapps'
		}
	);
	return _.template(template)(options);
};

module.exports = MyAppsList;



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/views/list-items/myapps-items.js
// module id = 46
// module chunks = 0